import React from 'react';
import styled from 'styled-components';
import SbEditable from 'storyblok-react';
import Components from '../components';

const CoverStripe = (props) => {
  const widthMap = {
    small: '200px',
    medium: '500px',
    large: '800px',
  };

  const backgroundColor = `${props.blok.background_color.color}${Math.ceil(
    (props.blok.background_opacity / 100.0) * 255
  ).toString(16)}`;

  return (
    <SbEditable content={props.blok}>
      <Stripe color={backgroundColor} width={widthMap[props.blok.width]}>
        {props.blok.content.map((blok) =>
          React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
        )}
      </Stripe>
    </SbEditable>
  );
};

const Stripe = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100%);
  left: -2rem;
  background-color: ${(props) => props.color};
  width: ${(props) => props.width};
  max-width: 100%;
  padding: 5%;

  @media (max-width: 899px) {
    left: 0;
    width: 100%;
  }
`;

export default CoverStripe;
